export const MATCH = 'MATCH'
import api from '../../../api'

export const MATCH_CONSTRUCTOR = "MATCH_CONSTRUCTOR";

const indexUpdate = 0;
const arrPatient = [];

export function editPatient(exam, val) {
	return (dispatch, getState) => {
	    return new Promise((resolve, reject) => {
	      	let match = {...getState().match};
	      	match.list.map((item) => {
	      		let a = [0, 1, 2, 4, 5, 6, 7, 8];
	      		if (a.indexOf(exam) != -1) {
	      			if (!!item.nameShow) {
	      				item.inforSearch = {
        					textSearch: '',
        					showSearch: val
        				};
	      			} else {
	      				item.inforSearch = {
        					textSearch: '',
        					showSearch: true
        				};
	      			}
	      		} else if (item._id == exam) {
	      			item.inforSearch = {
    					textSearch: '',
    					showSearch: val
    				};
	      		}
	      	})
	      	dispatch({
	        	type: MATCH_CONSTRUCTOR,
	        	payload: match
	      	});
	      	resolve();
	    })
   	}
}

export function editNoteExam(idmatch, val, note) {
	return (dispatch, getState) => {
	    return new Promise((resolve, reject) => {
	      	let match = {...getState().match};
       		if (val) {
       			match.temptNote = note;
       			match.notePopup = {
	        		id: idmatch,
	       			show: true,
	       			value: note
	       		}
       		} else {
       			match.notePopup.show = false;
       			match.list.map((item) => {
       				if (item._id == idmatch) {
       					item.updated = true;
       				}
       			})
       		}
	      	dispatch({
	        	type: MATCH_CONSTRUCTOR,
	        	payload: match
	      	});
	      	resolve();
	    })
   	}
}

export function popupSavedShow(val) {
	return (dispatch, getState) => {
	    return new Promise((resolve, reject) => {
	      	let match = {...getState().match};
       		match.popupSave = val;
	      	dispatch({
	        	type: MATCH_CONSTRUCTOR,
	        	payload: match
	      	});
	      	resolve();
	    })
   	}
}

export function eventUpdateList(limit, skip, setloading, data) {
	return (dispatch, getState) => {
	    return new Promise((resolve, reject) => {
	    	
	      	let match = {...getState().match};
	      	if (!!data) {
	      		match = data;
	      	}

	      	// api.get('/exams/?limit=' + match.paging.limit + '&skip=' + skip, null)
	      	let timePaging = new Date().getTime() - 1*60*1000;
	      	if (match.list.length == 0 || match.list.length != match.totalExam || match.paging.timing <= timePaging) {
	      		let loading = true;
	      		if (match.list.length == 0) {
	      			loading = false;
	      		}
	      		api.get('/search/exams/instapap?limit=' + limit + '&skip=' + match.list.length + '&sort=-date', null, loading)
		        .then(response => {
		        	let skipUpdated = response.exams;
		        	if (skipUpdated.length != 0) {
		        		var minu = (i) => {
							if (i < 10) {
						        i = "0" + i;
						    }
						    return i;
						}
		        		skipUpdated.map((item) => {
		        			let sethour = new Date(item.date).getHours();
						 	let hours = (sethour + 24) % 24; 
						    let mid = 'AM';
						    if (hours == 0) {
						    	hours = 12;
						    } else if (hours > 12) {
						    	hours = hours % 12;
						    	mid = 'PM';
						    }
		        			item.time = hours + ':' + minu(new Date(item.date).getMinutes()) + ' ' + mid;
		        			if (!!item.patient) {
		        				item.nameShow = item.patient.profile.name.first + ', ' + item.patient.profile.name.last;
		        				item.dobShow = item.patient.profile.dob;
		        				item.patient = item.patient._id;
		        				item.inforSearch = {
		        					textSearch: '',
		        					showSearch: false
		        				};
		        			} else {
		        				item.inforSearch = {
		        					textSearch: '',
		        					showSearch: true
		        				};
		        			}
		        			item.updated = false;
		        			item.points = item.points.length;
		        			match.list.push(item);
		        		})
		        	}
		        	match.totalExam = response.count;
		        	match.paging.loading = false;
		        	dispatch({
			        	type: MATCH_CONSTRUCTOR,
			        	payload: match
			      	});
			      	resolve();
		        }, err => {
		        	reject();
		        })
	      	} else {
	      		match.paging.loading = false;
	      		match.paging.theend = true;
	      		dispatch({
		        	type: MATCH_CONSTRUCTOR,
		        	payload: match
		      	});
		      	resolve();
	      	}
	    })
   	}
}

export function matchConstructor() {
  	return (dispatch, getState) =>{
	    return new Promise((resolve, reject)=>{
	    	let match = {...getState().match};
	    	match.totalExam = 0;
	        match.list = [];
	        match.popupSave = false;
	        match.popupDelete = false;
        	match.notePopup = {
        		id: 0,
       			show: false,
       			value: ''
       		};
       		match.paging = {
	    		skip: 0,
	    		limit: 8,
	    		timing: new Date().getTime(),
	    		theend: false,
	    		loading: false
	    	};
       		match.temptNote = '';
        	match.indexUpdate = indexUpdate;
    		match.arrPatient = [];
    		dispatch(eventUpdateList(match.paging.limit, match.paging.skip, true, match)); 
       //  	api.get('/patients', null)
	      //   .then(response => {
	      //   	response.patients.map((item) => {
	      //   		item.nameShow = item.profile.name.first + ', ' + item.profile.name.last;
	      //   	})
    			// match.arrPatient = response.patients;
	        	   
	      //   }, err => {
	      //   	reject();
	      //   })
	    })
  	}
}

export function deletePatient(show, val) {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	// api.get('/devices/')
		      //   .then(response => {
		       		
		      //   }, err => {
		      //   	reject();
		      //   })
	      	match.idmatchDelete = val;
	      	match.popupDelete = show;
	      	dispatch({
		        type: MATCH_CONSTRUCTOR,
		        payload: match
	      	});
	      	resolve();
	    })
   	}
}

export function deletePatientAccept() {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	let skip = match.paging.skip + match.paging.limit;
	      	api.delete('/exams/', [{"_id": match.idmatchDelete}], false)
	        .then(response => {
	        	match.popupDelete = false;
	        	match.list = match.list.filter((key,index)=>{
			      	return key._id != match.idmatchDelete;
		      	});
		      	dispatch(eventUpdateList(1, skip, true, match));
	        }, err => {
	        	reject();
	        })
	    })
   	}
}

export function updateNoteExam(note, dismiss) {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	if (dismiss) {
		      	match.list.map((item) => {
		      		if (item._id == match.notePopup.id) {
		      			item.notes.report = match.temptNote;
		      		}
		      	});
	      	} else {
	      		match.notePopup.value = note;
		      	match.list.map((item) => {
		      		if (item._id == match.notePopup.id) {
		      			item.notes.report = match.notePopup.value;
		      			item.updated = true;
		      		}
		      	});
	      	}	
	      	dispatch({
		        type: MATCH_CONSTRUCTOR,
		        payload: match
	      	});
	      	resolve();
	    })
   	}
}

export function updateMatchState(key, where, val) {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	if (key	== "textSearch") {
	      		match.list.map((item) => {
	      			if (item._id == where) {
	      				item.inforSearch.textSearch = val;
	      			}
	      		});
	      		clearInterval(match.count);
	      		match.count = setInterval(function() { 
	      			dispatch(callApiSearch(val));    
	      			clearInterval(match.count);
	      		}, 1000);
	      		dispatch({
		        	type: MATCH_CONSTRUCTOR,
		        	payload: match
		      	});
		      	resolve();
	      	} else if (key == "list") {
	      		match.list = where;
	      		dispatch({
			        type: MATCH_CONSTRUCTOR,
			        payload: match
		      	});
		      	resolve();
	      	}
	    })
   	}
}

export function callApiSearch(val) {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject) => {
	  		let match = {...getState().match};
	    	api.get('/search/patients?test_type=Instapap&name=' + val, null, true)
	        .then(response => {
	        	response.patients.map((item) => {
	        		item.nameShow = item.profile.name.first + ', ' + item.profile.name.last;
	        	})
	      		match.arrPatient = response.patients;
	        	dispatch({
		        	type: MATCH_CONSTRUCTOR,
		        	payload: match
		      	});
		      	resolve();
	        }, err => {
	        	reject();
	        })
	  	})
   	}
}

export function functionSavedAll() {
	return (dispatch, getState) => {
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	let count = 0;
       		let arrExamSave = [];
       		match.list.map((item) => {
       			if (!!item.nameShow) {
					arrExamSave.push({
						"patient": item.patient, 
						"_id": item._id,
						"notes": {
							"report": item.notes.report
						}
					});
       				count++;
       			}
       		});
       		match.count = count;
	      	let uncount = match.totalExam - count;
	      	match.updateSkip = count;
	      	match.totalExam = uncount;
       		if (count != 0) {
       			api.put('/exams/patients', arrExamSave)
		        .then(response => {
		       		// match.count = `${count} patient status ${count > 1 ? 'records were' : 'record was'} updated. ${uncount > 0 ? uncount + ' records still need to be reviewed' : ''}`;
		       		match.count = count; 
		       		match.uncount = uncount; 
		       		match.popupSave = true;
			      	dispatch({
				        type: MATCH_CONSTRUCTOR,
				        payload: match
			      	});
			      	resolve();
		        }, err => {
		        	reject();
		        })
       		} else {
       			resolve();
       		}
	    })
   	}
}

export function reviewNowAfterSaved() {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	// let match = {...getState().match};
	      	// match.list = match.list.filter((item, index) => {
	      	// 	return !item.nameShow
	      	// })
	      	// match.popupSave = false;
	      	// dispatch(matchConstructor());
	      	
	      	// dispatch({
		      //   type: MATCH_CONSTRUCTOR,
		      //   payload: match
	      	// });
	      	// resolve();
	    })
   	}
}

export function scrollPagingPage(dis) {
	return (dispatch, getState) =>{
	    return new Promise((resolve,reject)=>{
	      	let match = {...getState().match};
	      	let scrollHeight = (dis.target.scrollTop + (match.paging.limit * 64));
	      	let tableHeight = dis.target.scrollHeight - 64;
	      	if (scrollHeight >= tableHeight && !match.paging.loading) {
	      		match.paging.skip = match.paging.skip + match.paging.limit;
	      		match.paging.loading = true;
	      		dispatch(eventUpdateList(match.paging.limit, match.paging.skip, true));
	      	}		
	      	dispatch({
		        type: MATCH_CONSTRUCTOR,
		        payload: match
	      	});
	      	resolve();
	    })
   	}
}

const ACTION_HANDLERS = {
	[MATCH_CONSTRUCTOR]  : (state, action) => action.payload,
}

const initialState =  {
	popupSave: false,
	popupDelete: false
}
export default function reducer (state = initialState, action) {
  	const handler = ACTION_HANDLERS[action.type]
  	return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/routes/Match/modules/match.js